import React, {Component} from 'react';
import './Login.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import PhoneNumberForm from "./components/PhoneNumberForm";
import CodeForm from "./components/CodeForm";
import BackEnd from "../../backend/BackEnd";
import {token, userContext} from "../../auth/Auth";
import Dropdown from "../../controls/Dropdown";

class Login extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        step: 'PhoneNumber',
        phoneNumber: null,
        code: null,
        users: []
    };
    sendSecurityCode = new BackEnd.Authentication.SendSecurityCode(this);
    signIn = new BackEnd.Authentication.SignIn(this);

    constructor(props) {
        super(props);

        let host = window.location.host;
        this.enableEasyAuth = host.indexOf('localhost') !== -1 || host.indexOf('artlogics') !== -1;
    }

    render() {
        return (
            <div className="page-signin-container">
                {
                    this.state.step === 'PhoneNumber' &&
                    <PhoneNumberForm onSubmit={phoneNumber => this.submitPhoneNumber(phoneNumber)}/>
                }
                {
                    this.state.step === 'Code' &&
                    <CodeForm phoneNumber={this.state.phoneNumber}
                              onSubmit={code => this.codeSignIn(code)}/>
                }
                {
                    this.enableEasyAuth &&
                    <form className="panel p-a-4">
                        <fieldset className="form-group form-group-lg">
                            <label className="text-center m-b-2" htmlFor="phone-number">Выберите пользователя для
                                входа</label>
                            <Dropdown className="form-control" name="userId" id="userId"
                                      dataSource={new BackEnd.EasyAuth.SearchUsers()}
                                      onChange={event => this.setState({userId: event.target.value})}/>
                        </fieldset>
                        <button type="button" className="btn btn-block btn-lg btn-primary m-t-3"
                                disabled={!this.state.userId}
                                onClick={() => this.easySignIn()}>
                            Быстрый вход
                        </button>
                    </form>
                }
            </div>
        );
    }

    async submitPhoneNumber(phoneNumber) {
        if (this.state.isLoading) return;

        let result = await this.sendSecurityCode.call({
            dto: {phoneNumber}
        });

        this.setState({
            step: 'Code',
            phoneNumber
        });
    }

    async codeSignIn(code) {
        if (this.state.isLoading) return;

        let {response, json} = await this.signIn.extendedCall({
            dto: {
                phoneNumber: this.state.phoneNumber,
                securityCode: code
            }
        });

        userContext.set(json.data);
        token.set(response.headers.get('Bearer'));

        this.props.history.push('/');
    }

    async easySignIn() {
        let signIn = new BackEnd.EasyAuth.SignIn();
        let {response, json} = await signIn.extendedCall({
            dto: {
                userId: this.state.userId
            }
        });

        userContext.set(json.data);
        token.set(response.headers.get('Bearer'));

        this.props.history.push('/');
    }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/pages/Login/Login.js